const l = {
  name: "Anchor",
  dimensions: { width: 39, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.4 40" style="enable-background:new 0 0 39.4 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.7,0c-2.8,0-5,2.2-5,5c0,2.4,1.7,4.4,4,4.9V14h-4v2h4v22c-7.1-0.5-12.8-6.3-13-13.5L8,26.7l1.4-1.4
			l-4.7-4.7L0,25.3l1.4,1.4l2.3-2.3C3.9,33.1,11,40,19.7,40s15.8-6.9,16-15.6l2.3,2.3l1.4-1.4l-4.7-4.7L30,25.3l1.4,1.4l2.3-2.3
			c-0.2,7.2-5.9,13-13,13.5V16h4v-2h-4V9.9c2.3-0.5,4-2.5,4-4.9C24.7,2.2,22.5,0,19.7,0z M16.7,5c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3
			s-1.3,3-3,3C18.1,8,16.7,6.7,16.7,5z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Anchor
};
